import { render, staticRenderFns } from "./errorPaymentView.vue?vue&type=template&id=37a7060e&scoped=true&"
import script from "./errorPaymentView.vue?vue&type=script&lang=js&"
export * from "./errorPaymentView.vue?vue&type=script&lang=js&"
import style0 from "./errorPaymentView.vue?vue&type=style&index=0&id=37a7060e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7060e",
  null
  
)

export default component.exports